import { useEffect, useState } from "react";

import useToken from "../../auth/useToken";
import { usersService } from "../../../services/administration/usersService";
import { User } from "../../../types/features/administration/User";

interface Props {}

export default function useUsers({}: Props) {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>();
  const { token } = useToken();
  /**
   * Récupération des users avec filtres (provenant des props)
   */
  const getUsers = async () => {
    setLoading(true);
    try {
      // Backend now returns users already enriched with kyc_status and has_kyc
      const usersData = await usersService.getUsers(token);
      setUsers(usersData);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setError(error);
      setLoading(false);
    }
  };

  const deleteUser = async (userId: string) => {
    try {
      await usersService.deleteUser(userId);
      getUsers();
    } catch (error) {
      console.error(error);
      setError(error);
    }
  };

  const updateUser = async (updateUser: User) => {
    if (!updateUser.id) {
      alert("Une erreur s'est produite");
      return;
    }
    try {
      await usersService.updateUser(updateUser.id, updateUser);
      getUsers();
    } catch (error) {
      console.error(error);
      setError(error);
    }
  };

  /**
   * Recharger les users quand les filtres changent
   */
  useEffect(() => {
    getUsers();
  }, [token]); // dépendance sur les filtres

  return {
    users,
    getUsers,
    length: users.length,
    usersLoading: loading,
    usersError: error,
    deleteUser,
    updateUser,
  };
}
